import { render, staticRenderFns } from "./UserFormUpdate.vue?vue&type=template&id=bc67f2a2&scoped=true"
import script from "./UserFormUpdate.vue?vue&type=script&lang=ts"
export * from "./UserFormUpdate.vue?vue&type=script&lang=ts"
import style0 from "./UserFormUpdate.vue?vue&type=style&index=0&id=bc67f2a2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc67f2a2",
  null
  
)

export default component.exports